export function toggleFormRow(target: HTMLElement, cell: HTMLElement) {
  if (cell.style.display === 'none') {
    cell.style.display = 'table-cell';
    target.classList.add('active');
  } else {
    cell.style.display === "none";
    target.classList.remove('active');
  }
}
